import React, {useEffect, useState, useRef} from 'react';
import styles from './ReferralLandingPage.module.css';
import kra_icon from '../static_files/kira_icon_square.svg';
import star_icon from '../static_files/star.svg';
import ButtonWithHoverEffect from "./ButtonWithHoverEffect";
import {fetchPortfolioTrackRecordsRoundFourDigit} from "../linechart/fetchDailyPortfolioData";
import {useParams} from 'react-router-dom';

function ReferralLandingPage() {
    const [apy, setApy] = useState(0);
    const [displayedApy, setDisplayedApy] = useState("30-Day APY");
    const {referralCode} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const placeholderRef = useRef(null);
    const requestRef = useRef(null);
    const startTimeRef = useRef(Date.now());
    
    // 精确模拟CSS的@keyframes动画效果
    useEffect(() => {
        if (!isLoading || !placeholderRef.current) return;
        
        const animate = () => {
            const elapsedTime = (Date.now() - startTimeRef.current) % 1000;
            const percent = (elapsedTime / 1000) * 100;
            
            if (placeholderRef.current) {
                if (percent <= 50) {
                    placeholderRef.current.style.backgroundColor = "#464646";
                } else {
                    placeholderRef.current.style.backgroundColor = "#2A2A2A";
                }
            }
            
            requestRef.current = requestAnimationFrame(animate);
        };
        
        startTimeRef.current = Date.now();
        requestRef.current = requestAnimationFrame(animate);
        
        return () => {
            if (requestRef.current) {
                cancelAnimationFrame(requestRef.current);
            }
        };
    }, [isLoading]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await Promise.any([
                    fetchPortfolioTrackRecordsRoundFourDigit().catch(() => null),
                ]);

                if (data) {
                    // 计算最大 APY - Filter out null/NaN values before calculating max
                    const apyValues = [
                        { value: data.impliedApr, type: 'implied' },
                        { value: data.ninetyDayApy, type: 'ninety' },
                        { value: data.thirtyDayApy, type: 'thirty' }
                    ].filter(item => item.value != null && !isNaN(item.value));

                    let maxApy;
                    let maxApyType = "";

                    if (apyValues.length > 0) {
                        // Find the maximum value
                        const maxItem = apyValues.reduce((max, item) => 
                            item.value > max.value ? item : max
                        );
                        maxApy = maxItem.value;

                        // Determine the type based on which value was the max
                        if (maxApy === data.impliedApr) {
                            maxApyType = "Implied APY";
                        } else if (maxApy === data.ninetyDayApy) {
                            maxApyType = "90-Day APY";
                        } else if (maxApy === data.thirtyDayApy) {
                            maxApyType = "30-Day APY";
                        }
                    } else {
                        // Fallback if all values are null/NaN
                        maxApy = 0;
                        maxApyType = "Implied APY";
                    }

                    setApy(maxApy);
                    setDisplayedApy(maxApyType);
                    setIsLoading(false)
                }
            } catch (error) {
                console.error("Error fetching portfolio track records:", error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className={styles.pageContainer}>
            <div className={styles.headerContainer}
                 style={{display: 'flex', justifyContent: 'flex-start', width: "100%"}}></div>
            <div className={styles.mainContainer}>
                <img className={styles.kiraIcon} src={kra_icon} alt="0Max1"></img>

                <div className={styles.greenBox}>
                    <h1 className={styles.mainTitle}>USDi interest rewards are waiting for you</h1>
                    <p className={styles.subtitle}>
                        A friend invited you to join Kira and start earning interest today!
                    </p>

                    <ButtonWithHoverEffect referralCode={referralCode}></ButtonWithHoverEffect>
                    <div className={styles.infoBlock}>
                        <div className={styles.starContainer}><img className={styles.star_icon} src={star_icon}
                                                                   alt="Star"></img>

                            {isLoading ? (
                                <>
                                    <h2 className={`${styles.infoTitle} ${styles.infoTitle2}`}>{displayedApy}: </h2>
                                    <span
                                        ref={placeholderRef}
                                        style={{
                                            display: 'inline-block',
                                            width: '85px',
                                            height: '24px',
                                            marginLeft: '-5px',
                                            borderRadius: '6px',
                                            marginRight:"90px",
                                            backgroundColor: '#2A2A2A',
                                            transition: "background-color 0.8s ease",
                                        }}
                                        className={styles.blinkingLoader}
                                    />
                                </>
                            ) : (
                                <h2 className={styles.infoTitle}>{displayedApy}: {apy}%</h2>
                            )}
                        </div>
                        <p className={styles.infoDesc}>Start earning high, stable returns today.</p>
                    </div>

                    <div className={styles.infoBlock}>
                        <div className={styles.starContainer}><img className={styles.star_icon} src={star_icon}
                                                                   alt="Star"></img>
                            <h2 className={styles.infoTitle}>Delta Neutral Strategy</h2></div>
                        <p className={styles.infoDesc}>
                            Minimize risk while maximizing profits with our advanced trading approach.
                        </p>
                    </div>

                    <div className={styles.infoBlock}>
                        <div className={styles.starContainer}><img className={styles.star_icon} src={star_icon}
                                                                   alt="Star"></img>
                            <h2 className={styles.infoTitle}>Transparency &amp; Auditability</h2></div>
                        <p className={styles.infoDesc}>
                            Every transaction is verifiable, ensuring full trust and security.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReferralLandingPage;